// @flow

import React, { type Node } from 'react';
import { VoucherText } from './voucher-text';

type VoucherTextProps = {
  title: string,
}

export function RenderVoucherText ({title}: VoucherTextProps): Node {
  if (title === 'Número de Recaudación') {
    return <VoucherText onlyItem={true}>{title}</VoucherText>;
  }
  return <span>{title}</span>;
}
